import { render } from "./BrandLabel.vue?vue&type=template&id=3010fc0c&scoped=true"
import script from "./BrandLabel.vue?vue&type=script&lang=js"
export * from "./BrandLabel.vue?vue&type=script&lang=js"

import "./BrandLabel.vue?vue&type=style&index=0&id=3010fc0c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3010fc0c"]])

export default __exports__